<template>
    <div>
      <success-fade-alert ref="alert" :msg="alerts.success" />
      <fade-alert-danger ref="danger" :msg="alerts.error" />
  
      <b-overlay :show="!isInputsEnabled" rounded="lg" opacity="0.6">
        <template #overlay>
          <div class="d-flex align-items-center">
            <b-spinner class="align-middle"></b-spinner>
            <strong>{{ $t("geral.sendingData") }}</strong>
          </div>
        </template>
  
        <b-form-textarea
          id="input-descriptionDisapproval"
          v-model="disapprovalDescription"
          placeholder="Escrever a descrição da reprovação..."
          :disabled="!isInputsEnabled"
        />
  
        <div>
          <b-row>
            <b-col>
              <camera-button
                :lang="$i18n.locale"
                :disabled="!isInputsEnabled"
                :allow-documents="true"
                @update-image-src="fileAdd"
              >
              </camera-button>
            </b-col>
            <b-col class="text-right">
              <span v-if="isCommentLengthValid">{{ commentLength }}/500</span>
              <span v-else class="text-danger">
                Descrição da reprovação maior que o permitido.
                {{ commentLength }}/500
              </span>
            </b-col>
          </b-row>
  
          <b-row
            class="text-center"
            v-if="attachments != null && attachments.length > 0"
          >
            <b-col md="3" v-for="(attachment, i) in attachments" :key="i">
              <base-attachment-viewer
                class="ml-3 mb-3"
                :attachment="attachment"
                :discard-visible="isInputsEnabled"
                @discard="fileRemove"
              ></base-attachment-viewer>
              <!-- <base-attachment-item
                :attachment="attachment.attachment"
                :discard-visible="isInputsEnabled"
                @discard="fileRemove"
              >
              </base-attachment-item> -->
            </b-col>
          </b-row>
  
          <div>
            <b-button
              size="sm"
              class="mr-2"
              variant="green"
              :disabled="!isInputsEnabled"
              @click="saveComment"
            >
              {{ $t("checklist.form.DisapprovalPendency") }}
            </b-button>
            <b-button
              size="sm"
              class="mr-2"
              variant="danger"
              :disabled="!isInputsEnabled"
              @click="typingCancel"
            >
              {{ $t("geral.cancel") }}
            </b-button>
          </div>
        </div>
      </b-overlay>
    </div>
  </template>
  
  <script>
  // import BaseAttachmentItem from "@/components_rms/base/BaseAttachmentItem.vue";
  import CameraButton from "@/components_rms/CameraButton.vue";
  import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
  import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";
  import BaseAttachmentViewer from "@/components_rms/base/BaseAttachmentViewer.vue";
  
  export default {
    name: "PendencyDisapproval",
    components: {
      // BaseAttachmentItem,
      CameraButton,
      FadeAlertDanger,
      SuccessFadeAlert,
      BaseAttachmentViewer,
    },
    props: {
      pendencyId: Number,
    },
    data: function () {
      return {
        alerts: {
          error: "",
          success: "Pendencia aprovada com sucesso",
        },
        attachments: [],
        disapprovalDescription: "",
        isInputsEnabled: true,
      };
    },
    created: function () {},
    computed: {
      commentLength() {
        if (!this.disapprovalDescription) return 0;
        return this.disapprovalDescription.length;
      },
      isCommentLengthValid() {
        return this.commentLength <= 500;
      },
    },
    methods: {
      clearTyping() {
        this.attachments = [];
        this.disapprovalDescription = "";
      },
      fileAdd(newValue) {
        this.attachments.push({ attachment: newValue });
        this.$forceUpdate();
      },
      fileRemove(attachment) {
        for (let i = this.attachments.length - 1; i >= 0; i--) {
          if (this.attachments[i].attachment == attachment) {
            this.attachments.splice(i, 1);
            break;
          }
        }
        this.$forceUpdate();
      },
      saveComment() {
        this.isInputsEnabled = false;
  
        let pendencyDisapproval = {
          id: parseInt(this.pendencyId),
          disapprovalDescription: this.disapprovalDescription,
          attachments: [],
        };
        this.attachments.forEach((attach) => {
          let pendencyDisapprovalAttachment = {
            attachment: attach.attachment,
          };
          pendencyDisapproval.attachments.push(pendencyDisapprovalAttachment);
        });
  
        this.$apiChecklist
          .post("/pendencies/disapprove/", pendencyDisapproval)
          .then((response) => {
            this.$refs.alert.show();
            this.isInputsEnabled = true;
            this.clearTyping();
            this.$emit("after-disapproval");
          })
          .catch((error) => {
            console.log(error);
            if (error.response) {
              this.alerts.error = `${error.response.status} - ${error.response.statusText}`;
              this.$refs.danger.show();
              this.isInputsEnabled = true;
            } else {
              this.alerts.error = error;
              this.$refs.danger.show();
              this.isInputsEnabled = true;
            }
          });
      },
      typingCancel() {
        this.clearTyping();
        this.$emit("cancel-disapproval");
      },
    },
  };
  </script>
  
